import React from "react";
import { useSelector } from "react-redux";

const TourInformation = () => {
  const TourDetails = useSelector((state) => state.packageDetail.TourDetails);

  return (
    <div
      className="tab-pane fade show active"
      id="Tour"
      role="tabpanel"
      aria-labelledby="Tour-tab"
      dangerouslySetInnerHTML={{ __html: TourDetails?.TourInformation || "" }}
    />
  );
};

export default TourInformation;
